import React from "react";
import ChartIndexSelector from "../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartIndexSelector";

const TwitterPageSelector = ({ twitterPageList, setSelectedTwitterPage, selectedTwitterPage, widgetContainerRef }) => {
    let index = selectedTwitterPage.value;

    const handlePageChange = (d) => {
        const val = twitterPageList.find((page) => page.value === d);
        setSelectedTwitterPage(val);
    };

    return (
        <div className="chart-item-name">
            <ChartIndexSelector
                isTwitter
                currentName={selectedTwitterPage.label}
                currentIndex={index}
                options={twitterPageList}
                onIndexChange={(e) => handlePageChange(e)}
                widgetContainerRef={widgetContainerRef}
            />
        </div>
    );
};

export default TwitterPageSelector;
